import React, { useEffect, useState } from "react"
import { sign } from "@web-eid/web-eid-library/web-eid"

import { useAppDispatch } from "redux/hooks"
import { reset as resetVerification } from "redux/features/verification/verificationSlice"
import { reset as resetPolling } from "redux/features/polling/pollingSlice"
import { makePrepareIdCardSign } from "redux/features/sign/idCardThunk"
import { Container, Card } from "components/Sign/elements"
import IdCardForm from "components/Sign/IdCard/Form"
import Spinner from "components/ui/Spinner"
import {
  ClientIdCardSignPrepareFormValues,
  ClientIdCardSignResponseValues,
} from "types"

type Props = {
  signObject: {
    type: string
    id: number | string
  }
  onSubmit: (values: ClientIdCardSignResponseValues) => void
}

const IdCardSignComponent = ({ onSubmit, signObject }: Props) => {
  const dispatch = useAppDispatch()

  const [isSubmitting, setSubmitting] = useState(false)

  const handleSubmit = async (values: ClientIdCardSignPrepareFormValues) => {
    setSubmitting(true)

    const { certificate, supported_signature_algorithms } = values

    const signature_request_params = {
      id_card_sign: {
        certificate,
        supported_signature_algorithms,
        attacheable: signObject,
      },
    }

    const { digest_value, hash_function } = await dispatch(
      makePrepareIdCardSign(signature_request_params),
    )

    const { signature } = await sign(certificate, digest_value, hash_function, {
      lang: "en",
    })

    onSubmit({
      signature,
      certificate,
    })
  }

  const handleCancel = () => {
    dispatch(resetVerification())
    dispatch(resetPolling())
  }

  useEffect(() => {
    handleCancel()
  }, [])

  return (
    <Container>
      <Spinner open={isSubmitting} />
      <Card elevation={0}>
        <IdCardForm onSubmit={handleSubmit} />
      </Card>
    </Container>
  )
}

export default IdCardSignComponent
